import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { PostingFlow } from 'Douleutaras/types';

const QUOTE_RANGE_API_ENDPOINT = 'api/public/posting_flow';

type PostingFlowArgs = { categoryId: string | number; questions: {}; } | { jobId: string | number };

export const fetchPostingFlow = createAsyncThunk<PostingFlow, PostingFlowArgs>(
  'pros/posting_flow',
  async (args, api) => {
    let additionalGetParams;

    if ('questions' in args && args.hasOwnProperty('questions')) {
      const questions = {};

      Object.keys(args.questions)
        .forEach((questionKey, index) => {
          if (Array.isArray(args.questions[questionKey])) {
            questions[questionKey] = args.questions[questionKey][args.questions[questionKey].length - 1];

            return;
          }

          questions[questionKey] = args.questions[questionKey];
        });

      additionalGetParams = { category: args.categoryId, ...questions };
    }

    if ('jobId' in args && args.hasOwnProperty('jobId')) {
      additionalGetParams = { job_id: args.jobId };
    }

    const response = await makeRequest(
      `${QUOTE_RANGE_API_ENDPOINT}/`,
      {
        method: 'GET',
        additionalGetParams
      }
    )(api);

    return response.data !== '' ? response.data : {};
  }
);

export const postingFlowSlice = createSlice({
  name: 'postingFlow',
  initialState: {
    // This will be set to true on the first load and will stay as true
    loaded: false
  } as Partial<PostingFlow> & { loaded: boolean },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPostingFlow.fulfilled, (state, action) => {
      if (action.payload) {
        state = action.payload;
        state.loaded = true;
      }

      return state;
    });
  }
});
